import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error('Password must be at least 8 characters');
    if (password !== confirm) return toast.error("Passwords don't match");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      toast.success('Password updated. Please sign in.');
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFCF8] flex items-center justify-center p-8">
      <div className="w-full max-w-md">
        <Card className="border-stone-200 shadow-xl" data-testid="reset-password-card">
          <CardHeader>
            <CardTitle className="text-2xl font-heading">Choose a new password</CardTitle>
            <CardDescription>At least 8 characters.</CardDescription>
          </CardHeader>
          <CardContent>
            {!token ? (
              <p className="text-stone-700">
                This link is missing its code. <Link to="/forgot-password" className="text-[#D97757] hover:underline">Request a new one</Link>.
              </p>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="space-y-2">
                  <Label htmlFor="password" className="text-stone-700">New password</Label>
                  <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                    className="h-11 rounded-lg border-stone-200 focus:border-[#D97757] focus:ring-[#D97757]" data-testid="reset-password-input" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="confirm" className="text-stone-700">Confirm new password</Label>
                  <Input id="confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
                    className="h-11 rounded-lg border-stone-200 focus:border-[#D97757] focus:ring-[#D97757]" data-testid="reset-password-confirm-input" />
                </div>
                <Button type="submit" className="w-full h-11 rounded-full bg-stone-900 text-white hover:bg-stone-800 font-medium"
                  disabled={loading} data-testid="reset-password-submit-btn">
                  {loading ? 'Saving...' : 'Save new password'}
                </Button>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
